import {
  AMOUNT_ZERO,
  Address,
  ChainPublicClientService,
  getChainKey,
  getIsWrappedNative,
  makeAmount,
} from "@silo/types";
import { Effect } from "effect";
import { isNullable } from "effect/Predicate";
import { erc20Abi, getContract } from "viem";
import { getBalance } from "viem/actions";
import { ContractsClientError } from "./types";

export type GetTokenBalance = ReturnType<typeof getTokenBalance>;
export type GetTokenBalanceSuccess = Effect.Effect.Success<GetTokenBalance>;
export type GetTokenBalanceError = Effect.Effect.Error<GetTokenBalance>;
export type GetTokenBalanceContext = Effect.Effect.Context<GetTokenBalance>;

export function getTokenBalance(tokenAddress: Address, user: Address | null) {
  return Effect.gen(function* () {
    if (isNullable(user)) return AMOUNT_ZERO;

    const { publicClient } = yield* ChainPublicClientService;

    const tokenContract = getContract({
      address: tokenAddress,
      abi: erc20Abi,
      client: publicClient,
    });

    const chainKey = getChainKey(publicClient.chain.id);
    const isWrappedNative = getIsWrappedNative(chainKey)(tokenAddress);

    const tokenBalance = yield* Effect.tryPromise({
      try: () => {
        if (isWrappedNative) {
          return getBalance(publicClient, { address: user });
        }

        return tokenContract.read.balanceOf([user]);
      },
      catch: (cause) => new ContractsClientError({ cause }),
    });

    return makeAmount(tokenBalance);
  });
}
